<template>
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
    <a-form layout="inline" :form="dataForm" @submit="getDataList" class="pb-10">
      <a-form-item label="客户姓名">
        <a-input v-model="dataForm.customer_name" placeholder="客户姓名搜索"></a-input>
      </a-form-item>
      <a-form-item label="客户手机号">
        <a-input v-model="dataForm.customer_phone" placeholder="客户手机号搜索"></a-input>
      </a-form-item>
      <a-form-item label="运营人员">
        <a-select v-model="dataForm.op_userid" style="width: 240px" placeholder="选择运营负责人" option-label-prop="label"
          :filter-option="filterOption" showSearch allowClear>
          <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
            {{ v.real_name }}
            <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
              ({{ v.department.department_name }})
            </span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="会员合同">
        <a-select v-model="dataForm.contract" style="width: 120px" placeholder="请选择" allowClear>
          <a-select-option value="1"> 已签署 </a-select-option>
          <a-select-option value="2"> 未签署 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="会员等级">
        <a-input v-model="dataForm.vip_key" placeholder="会员等级搜索"></a-input>
      </a-form-item>
      <a-form-item label="会员状态">
        <a-select v-model="dataForm.vip" style="width: 120px" placeholder="请选择" allowClear>
          <a-select-option value="1"> 已入会 </a-select-option>
          <a-select-option value="2"> 未入会 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="缴费时间">
        <a-range-picker @change="onChangeTime" allowClear value-format="yyyy/MM/DD" />
      </a-form-item>
      <!-- <a-form-item label="初次邀请入会经理">
        <a-select v-model="dataForm.first_joinuser" style="width: 240px" placeholder="初次邀请入会经理搜索"
          option-label-prop="label" :filter-option="filterOption" showSearch allowClear>
          <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
            {{ v.real_name }}
            <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
              ({{ v.department.department_name }})
            </span>
          </a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item label="行程订单时间">
        <a-range-picker @change="onChangeTime2" allowClear value-format="yyyy/MM/DD" />
      </a-form-item>
      <a-form-item label="入会渠道">
        <a-select v-model="dataForm.comefrom" style="width: 120px" placeholder="请选择" allowClear>
          <a-select-option value="1"> 后台手动录入 </a-select-option>
          <a-select-option value="2"> 客户手动录入 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="piliang">批量导入客户</a-button>
      </a-form-item>
      <a-form-item v-permission="['admin:customer:export']">
        <a-button @click="exportlist">导出客户</a-button>
      </a-form-item>
    </a-form>
    <a-row :gutter="10">
      <a-col :span="5">
        <DepartmentUsers :departmentlist="departmentlist" @onSelect="onSelect" :department_id="dataForm.department_id"
          :user_id="dataForm.user_id"></DepartmentUsers>
      </a-col>
      <a-col :span="19">
        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="customer_id"
          :loading="dataListLoading" :scroll="{ x: 1400 }">
          <!-- <template slot="customer_name" slot-scope="customer_name, row">
            <a-button type="link" class="font-regular p-0 btn-edit">{{
              customer_name
              }}</a-button>
          </template> -->
          <template slot="contract" slot-scope="contract">
            <a-tag :color="contract == 1 ? 'green' : 'red'">{{ contract == 1 ? '已签署' : contract == 2 ? '未签署' : '未录入'
            }}</a-tag>
          </template>
          <template slot="memberChildren" slot-scope="memberChildren">
            <div v-if="memberChildren.length > 0">
              <a-tag color="blue" v-for="v in memberChildren">{{ v.vip_key }}</a-tag>
            </div>
            <a-tag color="red" v-else>未入会</a-tag>
          </template>
          <template slot="action" slot-scope="text, row">
            <a-button type="link" @click="CustomerDetail(row)">查看客户档案</a-button>
          </template>
        </a-table>
        <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
          :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
          @change="pageCurrentChangeHandle" />
      </a-col>
    </a-row>
    <Customer ref="customer" @ok="query" @newCustomerid="newCustomerid"></Customer>
    <piliang ref="piliang" @ok="getDataList"></piliang>
  </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import Customer from "@/components/Customer/index.vue";
import "element-ui/lib/theme-chalk/index.css";
import piliang from "./piliang.vue";
import qs from 'qs';
import DepartmentUsers from '@/components/DepartmentUsers/index.vue'
export default {
  mixins: [viewModule],
  components: {
    Customer,
    piliang,
    DepartmentUsers
  },
  activated() {
    if (!!this.beforCustomerid) {
      this.$refs.customer.visible = true
      this.$refs.customer.resetlist()
    }
  },
  data() {
    return {
      beforCustomerid: "",
      treeData: [
        {
          title: "众诚国际旅行社",
          key: "0-0",
          slots: {
            icon: "smile",
          },
          children: [
            { title: "销售部", key: "0-0-0", slots: { icon: "meh" } },
            { title: "基调不", key: "0-0-1", scopedSlots: { icon: "custom" } },
          ],
        },
      ],
      userList: [],
      dataForm: {
        customer_name: "",
        customer_phone: "",
        contract: undefined,
        vip: undefined,
        department_id: undefined,
        user_id: undefined,
        comefrom: undefined,
        vip_key: ""
      },
      mixinViewModuleOptions: {
        getDataListURL: "/admin/customer/page",
        deleteURL: "/admin/customer/delete",
      },
      columns: [
        {
          title: "姓名",
          dataIndex: "customer_name",
          // scopedSlots: { customRender: "customer_name" },
          width: 120
        },
        {
          title: "手机号",
          dataIndex: "customer_phone",
          width: 150
        },
        {
          title: "销售",
          dataIndex: "managerinfo.user.real_name",
          width: 120
        },
        {
          title: "是否签署会员合同",
          dataIndex: "contract",
          scopedSlots: { customRender: "contract" },
          width: 160
        },
        {
          title: "会员等级",
          dataIndex: "memberChildren",
          scopedSlots: { customRender: "memberChildren" },
          width: 200
        },
        {
          title: "身份证号",
          dataIndex: "id_no",
          width: 120
        },
        {
          title: "性别",
          dataIndex: "gender_text",
          width: 80
        },
        // {
        //   title: "初次入会时间",
        //   dataIndex: "first_jointime",
        //   width: 200
        // },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 200
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 200
        },
      ],
      departmentlist: [],
      userList: []
    };
  },
  mounted() {
    this.getAllDepartmentList();
    this.getUserList()
  },
  methods: {
    newCustomerid(id) {
      this.beforCustomerid = id
    },
    piliang() {
      this.$refs.piliang.init()
    },
    getUserList() {
      this.$http({
        url: "/admin/user/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.userList = res.data.result;
      });
    },
    getAllDepartmentList() {
      this.$http({
        url: "/admin/user/getDepartmentSon",
        method: "get",
      }).then((res) => {
        this.departmentlist = res.data;
      });
    },
    onChangeTime(e) {
      if (e.length == 2) {
        this.dataForm.join_start = `${e[0]} 00:00:00`
        this.dataForm.join_end = `${e[1]} 23:59:59`
      } else {
        this.dataForm.join_start = undefined
        this.dataForm.join_end = undefined
      }
    },
    onChangeTime2(e) {
      if (e.length == 2) {
        this.dataForm.trip_start = `${e[0]} 00:00:00`
        this.dataForm.trip_end = `${e[1]} 23:59:59`
      } else {
        this.dataForm.trip_start = undefined
        this.dataForm.trip_end = undefined
      }
    },
    CustomerDetail(row) {
      this.$refs.customer.init(row);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    //选择
    onSelect(info) {
      console.log(JSON.parse(JSON.stringify(info)));
      const department_id = info.department_id;
      const user_id = info.user_id;
      this.dataForm.department_id = department_id;
      this.dataForm.user_id = user_id;
      this.getDataList();
    },
    //导出项目列表
    exportlist() {
      const queryString = qs.stringify(this.dataForm);
      this.$http({
        url: '/admin/customer/exportDataToExcel?' + queryString,
        method: 'get',
        data: this.dataForm,
        responseType: 'blob'
      }).then(data => {
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `客户表导出.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
    },
  },
};
</script>